import { IonButton } from '@ionic/react';
import { useState } from 'react';
import { listLocalOperationalEvidencePreviews } from '../lib/haccp/operationalEvidenceOutbox.js';
import { getSupabase } from '../lib/supabase.js';

export function RegisterPhotoView({ tenantId, path }: { tenantId: string; path: string }): JSX.Element {
  const [source, setSource] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  async function open() {
    setBusy(true); setMessage(null);
    try {
      const local = await listLocalOperationalEvidencePreviews(tenantId, [path]);
      if (local[path]) { setSource(local[path].dataUrl); return; }
      if (!navigator.onLine) { setMessage('Foto già sincronizzata: collega il dispositivo per aprirla.'); return; }
      const result = await getSupabase().storage.from('operational-evidence').createSignedUrl(path, 300);
      if (result.error || !result.data) throw new Error('Foto non ancora disponibile: attendi la sincronizzazione oppure riprova.');
      setSource(result.data.signedUrl);
    } catch (error) { setMessage(error instanceof Error ? error.message : 'Impossibile aprire la foto'); }
    finally { setBusy(false); }
  }
  return <div><IonButton fill="clear" disabled={busy} onClick={() => source ? setSource(null) : void open()}>{source ? 'Chiudi foto' : busy ? 'Apertura foto…' : 'Vedi foto'}</IonButton>
    {source && <img src={source} alt="Fotografia del controllo registrato" style={{maxWidth:'100%',maxHeight:320}} onError={() => {setSource(null);setMessage('Foto non disponibile: riprova dopo la sincronizzazione.');}} />}
    {message && <p role="status">{message}</p>}
  </div>;
}
